import { render, staticRenderFns } from "./ButtonContents.vue?vue&type=template&id=3efb3190&"
import script from "./ButtonContents.vue?vue&type=script&lang=js&"
export * from "./ButtonContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports